<template>
  <div class="tip">
    <img class="warning-img" src="@/assets/views/map/icon/yes.png" alt />
    <span class="warning-text">标注信息已保存</span>
    <!--<span class="warning-text">确认删除？</span>
    <div class="btn">
      <div class="yes-btn" @click="del">确认</div>
      <div class="no-btn" @click="noDel">取消</div>
    </div>-->
  </div>
</template>

<script>
export default {
  name: "deleteMap",
  data() {
    return {};
  },
  created() {},
  mounted() {},
  methods: {
    del() {
      this.$emit("del", !0);
    },
    noDel() {
      this.$emit("notdel", !!0);
    }
  }
};
</script>

<style lang="scss" scoped>
@mixin center() {
  display: flex;
  justify-content: center;
  align-items: center;
}
.tip {
  @include center;

  .warning-img {
    width: 23.6px;
    height: 23.6px;
    margin: 0;
    @include center;
  }
  .warning-text {
   font-family: PingFangSC-Regular;
font-size: 20px;
color: #FFFFFF;
    text-align: center;
    margin-left: 20px;
  }
}
</style>
